"use strict";

/**
 * Flow Chart Block JavaScript
 * Handles interactive button clicks and response display
 */

(function () {
  'use strict';

  // Initialize flow chart functionality
  function initFlowChart() {
    var flowCharts = document.querySelectorAll('.flow-chart-block__flow-chart');
    flowCharts.forEach(function (flowChart) {
      var buttons = flowChart.querySelectorAll('.flow-chart-block__response-button');
      var responseContents = flowChart.querySelectorAll('.flow-chart-block__response-content');
      var buttonsRow = flowChart.querySelector('.flow-chart-block__buttons-row');
      var responsesRow = flowChart.querySelector('.flow-chart-block__responses-row');
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var responseId = this.getAttribute('data-response-id');
          var targetContent = document.getElementById(responseId);
          if (!targetContent || !buttonsRow || !responsesRow) {
            return;
          }

          // Hide all response contents in this flow chart
          responseContents.forEach(function (content) {
            content.style.display = 'none';
            content.style.setProperty('--triangle-position', '50%');
          });

          // Remove active class from all buttons in this flow chart
          buttons.forEach(function (btn) {
            btn.classList.remove('active');
          });

          // Show the selected response content
          if (targetContent.style.display === 'none' || !targetContent.style.display) {
            // Temporarily show content to get accurate measurements (but keep it invisible)
            var wasHidden = targetContent.style.display === 'none' || !targetContent.style.display;
            if (wasHidden) {
              targetContent.style.display = 'block';
              targetContent.style.visibility = 'hidden';
              targetContent.style.position = 'absolute';
              targetContent.style.opacity = '0';
            }

            // Get all positions
            var buttonRect = button.getBoundingClientRect();
            var buttonsRowRect = buttonsRow.getBoundingClientRect();
            var contentRect = targetContent.getBoundingClientRect();
            var responsesRowRect = responsesRow.getBoundingClientRect();

            // Calculate button center relative to buttons row center
            var buttonsRowCenter = buttonsRowRect.left + buttonsRowRect.width / 2;
            var buttonCenterX = buttonRect.left + buttonRect.width / 2;
            var buttonOffsetFromCenter = buttonCenterX - buttonsRowCenter;

            // Calculate content center relative to responses row center
            var responsesRowCenter = responsesRowRect.left + responsesRowRect.width / 2;
            var contentCenterX = contentRect.left + contentRect.width / 2;

            // Apply the same offset to the content
            var targetTriangleX = responsesRowCenter + buttonOffsetFromCenter;

            // Calculate triangle position within content box (as percentage)
            var contentLeft = contentRect.left;
            var triangleOffset = targetTriangleX - contentLeft;
            var trianglePosition = triangleOffset / contentRect.width * 100;

            // Clamp the position to stay within reasonable bounds (5% to 95%)
            var clampedPosition = Math.max(5, Math.min(95, trianglePosition));

            // Set CSS variable for triangle position
            targetContent.style.setProperty('--triangle-position', clampedPosition + '%');

            // Now show it properly
            if (wasHidden) {
              targetContent.style.visibility = 'visible';
              targetContent.style.position = 'relative';
              targetContent.style.opacity = '1';
            }
            this.classList.add('active');
          } else {
            targetContent.style.display = 'none';
            this.classList.remove('active');
          }
        });
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlowChart);
  } else {
    initFlowChart();
  }

  // Re-initialize for dynamically loaded content (e.g., AJAX)
  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('flowChartInit', initFlowChart);
  }
})();